import React, { useState } from "react";
import { useParams } from "react-router-dom";
import useClientAppSignupRequest from "../../hooks/useClientAppSignupRequest";
import PageLayout from "../../components/PageLayout";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import SignupSubmission from "./SignupSubmission";
import Thanks from "./Thanks";
import StepFlowNavigate from "../../components/StepFlowNavigate";
import SignupTemporarilySuspended from "./SignupTemporarilySuspended";
import { buildSignupSteps, initialSignupFlowState } from "./signupSteps";

const SignupFlow = (props) => {
  const { signupId } = useParams();
  const [flowCompleted, setFlowCompleted] = useState(false);

  const { loading, error, signupRequest, signupsEnabled, signupsDisabledReason, submitted } = useClientAppSignupRequest(
    `/api/signup/${signupId}`,
  );

  if (!!loading) {
    return null;
  }

  if (submitted || flowCompleted) {
    return (
      <PageLayout>
        <Thanks />
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout>
        <ScrollToTop />
        <Card title="Sorry, that didn't work" removeTopPadding>
          {error}
        </Card>
      </PageLayout>
    );
  }

  if (signupsEnabled === false) {
    return <SignupTemporarilySuspended reason={signupsDisabledReason} />;
  }

  return (
    <PageLayout>
      <StepFlowNavigate
        initialFlowState={{ leadId: signupId, ...initialSignupFlowState(signupRequest) }}
        steps={buildSignupSteps({
          isBuyToLet: signupRequest.isBuyToLet,
          finalSteps: [
            {
              name: "Submit",
              slug: "submit",
              component: (flowState) => (
                <SignupSubmission
                  transactionType={flowState.transactionType}
                  signupFlowState={flowState}
                  onFlowComplete={() => setFlowCompleted(true)}
                />
              ),
            },
          ],
        })}
      />
    </PageLayout>
  );
};

export default SignupFlow;
